import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-button-labeled',
  templateUrl: './button-labeled.component.html',
})
export class ButtonLabeledComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
